<template>
  <div class="sp_home">
    <heade-title :title="title"></heade-title>

    <div class="sp_overall">
      <p class="overall_title">Overall</p>
      <!-- <el-row class="content"
              :gutter="20">
        <el-col class="overall-content"
                :span="4"
                v-for="val in overallCard"
                :key="val.id"> -->
      <div class="content">
        <div v-for="val in overallCard"
             :key="val.id"
             class="overall_card"
             :style="{'background-color':val.background}">
          <span class="overall_card_num"
                :loading="loadingNum">{{val.num}}</span>
          <span class="overall_card_count">{{val.count}}</span>
          <svg-icon class="svg-icon"
                    :icon-class="val.iconClass" />
        </div>
      </div>
      <!-- </el-col>
      </el-row> -->
    </div>
    <div class="background"></div>

    <el-row class="case-info"
            style="background:#fff; padding:0 16px 16px;">
      <el-col :span="24">
        <p style="font-size:16px; color:#13161a; height:48px; line-height:48px; font-weigth:500;">Case Info</p>
      </el-col>
      <el-col class="case-table"
              :span="24">
        <el-table :data="tableData"
                  tooltip-effect="dark"
                  style="width: 100%"
                  border
                  ref="myTable"
                  class="table"
                  :header-cell-style="setHeadeStyle"
                  size="medium"
                  v-loading="tableLoading">
          <el-table-column label="#"
                           width="52"
                           align="center"
                           type="index"></el-table-column>
          <el-table-column show-overflow-tooltip
                           :render-header="renderHeader"
                           label="Case ID"
                           prop="caseNo"></el-table-column>
          <el-table-column show-overflow-tooltip
                           :render-header="renderHeader"
                           label="Company Name"
                           prop="customer"></el-table-column>
          <el-table-column show-overflow-tooltip
                           :render-header="renderHeader"
                           label="Product">
            <template slot-scope="scope">
              <span>{{prodectDic[scope.row.product]}}</span>
            </template>
          </el-table-column>
          <el-table-column label="Title"
                           prop="issueTitle"
                           show-overflow-tooltip
                           :render-header="renderHeader"></el-table-column>
          <el-table-column label="Description"
                           prop="issueDescriptions"
                           show-overflow-tooltip
                           :render-header="renderHeader"></el-table-column>
          <el-table-column show-overflow-tooltip
                           :render-header="renderHeader"
                           label="Status">
            <template slot-scope="scope">
              <span :style="statusStyle[scope.row.status]">{{scope.row.status==0?'Closed':'Open'}}</span>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip
                           :render-header="renderHeader"
                           label="Issue Severity">
            <template slot-scope="scope">
              <span :style="impactLevelDic[scope.row.impactLevel].color">
                <!-- <svg-icon icon-class="fire" />  -->
                {{impactLevelDic[scope.row.impactLevel].name}}
              </span>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip
                           :render-header="renderHeader"
                           label="Update Date"
                           width="160">
            <template slot-scope="scope">
              <span>{{moment(scope.row.modifiedDate).format('YYYY-MM-DD HH:mm:ss')}}</span>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip
                           :render-header="renderHeader"
                           label="Submit by"
                           prop="createdByName"></el-table-column>
          <el-table-column label="Contact Person"
                           prop="contact"
                           show-overflow-tooltip
                           :render-header="renderHeader"></el-table-column>
        </el-table>
      </el-col>
      <el-col :span="24"
              class="pagination"
              style="text-align:right;">
        <el-pagination @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :page-sizes="pageSizes"
                       :page-size="filter.pageSize"
                       :disabled="total < 10"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="total">
        </el-pagination>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import headeTitle from '../../components/headeTitle.vue'
import { tableMixis } from "@/mixins/tableMixis.js"
import { getOverallApi } from '@/api/common.js'
import { getProductApi, getCaseListApi } from "@/api/case.js"
import moment from 'moment'
export default {
  components: { headeTitle },
  mixins: [tableMixis],
  name: "home",
  data () {
    return {
      title: "Home",
      overallCard: [
        { id: 1, background: '#616DF2', iconClass: 'inactivated', num: 0, count: 'Inactivated devices', name: "inactivatedCount" },
        { id: 2, background: '#30C090', iconClass: 'activated', num: 0, count: 'Activated devices', name: "activatedCount" },
        { id: 3, background: '#FA830C', iconClass: 'expired', num: 0, count: 'Expired devices', name: "expiredCount" },
        { id: 4, background: '#FCC200', iconClass: 'soon', num: 0, count: 'Devices expires within one month', name: "expiresWithinMonthCount" },
        { id: 5, background: '#2684FF', iconClass: 'opencase', num: 0, count: 'Open Case', name: "openCaseCount" },
        { id: 6, background: '#77808C', iconClass: 'closecase', num: 0, count: 'Closed Case', name: "closeCaseCount" },
      ],
      tableData: [],
      filter: {
        beginTime: "",
        endTime: '',
        status: '',
        product: [],
        keyword: '',
        pageSize: 10,
        pageNumber: 1,
      },
      tableData: [],
      loadingNum: false,
      tableLoading: false,
      impactLevelDic: {
        4: {
          name: "Low", color: {
            color: "#2684FF", background: '#EBF3FF', padding: '0 8px', height: '22px',
            'line-height': '22px', display: 'inline-block',
          }
        },
        3: {
          name: "Medium", color: {
            color: "#FF9500", background: '#FCF0E3', padding: '0 8px', height: '22px',
            'line-height': '22px', display: 'inline-block',
          }
        },
        2: {
          name: "High", color: {
            color: "#D94B4B", background: '#FCE8E8', padding: '0 8px', height: '22px',
            'line-height': '22px', display: 'inline-block',
          }
        },
        1: {
          name: "Critical", color: {
            color: "#900E0E", background: '#F3E6E6', padding: '0 8px', height: '22px',
            'line-height': '22px', display: 'inline-block',
          }
        },
      },
      statusStyle: {
        0: {
          padding: '0px 10px',
          borderRadius: '45px',
          background: '#79828C',
          display: 'inline-block',
          height: '22px',
          'line-height': '22px',
          color: '#fff',
        },
        1: {
          padding: '0px 10px',
          borderRadius: '45px',
          background: '#32C093',
          display: 'inline-block',
          height: '22px',
          'line-height': '22px',
          color: '#fff',
        }
      },
      productList: [],
    }
  },

  methods: {

    //表头样式
    renderHeader (h, data) {
      return h("span", [
        h(
          "el-tooltip",
          {
            attrs: {
              class: "item",
              effect: "dark",
              content: data.column.label,
              placement: "top",
              color: '#ffffff'
            },
          },
          [h("span", data.column.label)]
        ),
      ]);
    },
    //获取overall信息
    getOverall () {
      this.loadingNum = true;
      getOverallApi().then(res => {
        this.overallCard.forEach(val => {
          val.num = res.rows[val.name]
        })
        this.loadingNum = false;
      }).catch(() => {
        this.overallCard.forEach(val => {
          val.num = 0
        })
        this.loadingNum = false;
      })
    },

    //获取工单列表
    handleSearch (data) {
      this.tableLoading = true;
      let params = JSON.parse(JSON.stringify(data))
      params.channelId = this.$store.getters.userInfo.corpsName
      delete params.status
      getCaseListApi(params).then(res => {
        this.tableLoading = false;
        this.tableData = res.rows.rows;
        this.total = res.rows.total
      }).catch(() => {
        this.tableData = [];
        this.total = 0;
        this.tableLoading = false;
      })
    },

    //获取产品线
    getproductList () {
      getProductApi({}).then(res => {
        this.productList = res.rows;
        this.$ls.set('product', res.rows)
      })
    },
  },
  watch: {
    '$store.getters.userInfo.corpsName': {
      handler (val) {
        if (val) {
          this.handleSearch(this.filter)
        }
      },
      immediate: true
    }
  },
  created () {
    this.getOverall()
    // this.handleSearch(this.filter)
    this.getproductList()
  },
  mounted () {
    this.$refs.myTable.$el.children[1].style.width = 'calc( 100% - 10px)';
  },

  computed: {
    moment () {
      return moment
    },

    prodectDic () {
      let dicObj = {};
      for (var i in this.productList) {
        let key = Object.values(this.productList[i])[0]
        dicObj[key] = Object.values(this.productList[i])[2]
      }
      return dicObj
    },
  }
}
</script>

<style scoped lang="scss">
.sp_home {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  .sp_overall {
    width: 100%;
    background: #fff;
    padding: 0 16px 16px;
    box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.08);
    .overall_title {
      width: 100%;
      font-size: 16px;
      font-weight: 500;
      color: #13161a;
      font-weight: 500;
      line-height: 48px;
      height: 48px;
    }
    .content {
      display: flex;
      justify-content: space-between;
      flex-wrap: nowrap;
    }
    .overall_card:nth-child(1) {
      margin-left: 0px !important;
    }
    .overall_card:nth-child(6) {
      margin-right: 0px !important;
    }
    .overall_card {
      width: 16.67%;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      background-size: cover;
      padding: 13px 18px;
      border-radius: 4px;
      margin: 0 6px;
      position: relative;
      .overall_card_num {
        width: 100%;
        text-align: center;
        font-size: 30px;
        font-weight: 500;
        color: #fff;
        line-height: 42px;
      }
      .overall_card_count {
        width: 100%;
        text-align: center;
        color: #fff;
        font-size: 16px;
        font-weight: 500;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .svg-icon {
        position: absolute;
        bottom: 0;
        right: 0;
        height: 59px;
        width: 63px;
        opacity: 0.2;
        color: #ffffff;
      }
    }
  }
  .background {
    height: 12px;
    background-color: #f0f3f7;
  }
  .case-info {
    position: relative;
    height: calc(100% - 228px);
    .case-table {
      height: calc(100% - 96px);
      .table {
        height: 100%;
        /deep/.el-table__body-wrapper {
          height: calc(100% - 41px);
          overflow-y: auto;
          // overflow-x: auto;
        }
        /deep/.el-table__fixed-right .el-table__fixed-body-wrapper,
        .el-table__fixed-right .el-table__fixed-footer-wrapper,
        .el-table__fixed-right .el-table__fixed-header-wrapper {
          // overflow-y: auto !important;
          height: calc(100% - 41px) !important;
          // pointer-events: none !important;
        }
      }
    }
    .pagination {
      margin-right: 0 !important;
      .el-pagination {
        height: 48px;
        margin-right: 0px !important;
        padding-right: 0px !important;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        /deep/.el-pagination__editor {
          margin-left: 10px !important;
          padding: 0 !important;
        }
        /deep/.el-pager li.disabled {
          color: #ffffff !important;
        }
      }
    }
  }
}
::v-deep .el-table th.el-table__cell > .cell {
  // word-break: break-word;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>